import { usePersona } from '../../personas/hooks/usePersona';
import { useGenerateRandomName } from './useGenerateRandomName';

export const useGeneratePersona = () => {
    const { createRecord } = usePersona();
    const { generateName } = useGenerateRandomName();

    const generate = async (count: number = 1) => {
        const promises = [];
        for (let i = 0; i < count; i++) {
            const { givenName, familyName, email } = generateName();
            const persona = {
                givenName,
                familyName,
                email,
                status: 'ENABLED',
            };
            promises.push(createRecord(persona as any));
        }
        await Promise.all(promises);
    };

    return { generate };
};
